import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Card } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';

export function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Welcome back!');
      nav('/');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Login failed');
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto py-8">
      <Card className="glass p-6 sm:p-8">
        <h1 className="font-display text-3xl font-black">Welcome back</h1>
        <p className="text-slate-400 text-sm mt-1">Sign in to keep earning JXP</p>
        <form onSubmit={submit} className="space-y-4 mt-6">
          <div>
            <Label>Email</Label>
            <Input data-testid="login-email" type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="you@jixxeo.ai" />
          </div>
          <div>
            <Label>Password</Label>
            <Input data-testid="login-password" type="password" required value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" />
          </div>
          <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full gradient-brand text-white">
            {loading ? 'Signing in…' : 'Sign in'}
          </Button>
        </form>
        <div className="text-sm text-slate-400 mt-6 text-center">
          No account? <Link to="/register" className="text-violet-400 hover:underline">Create one</Link>
        </div>
      </Card>
    </div>
  );
}

export function RegisterPage() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: '', password: '', username: '', display_name: '', referral_code: '' });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success('Welcome to Jixxeo AI — +10 JXP');
      nav('/');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Register failed');
    } finally { setLoading(false); }
  };
  const u = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="max-w-md mx-auto py-8">
      <Card className="glass p-6 sm:p-8">
        <h1 className="font-display text-3xl font-black">Create account</h1>
        <p className="text-slate-400 text-sm mt-1">Start earning JXP from day one</p>
        <form onSubmit={submit} className="space-y-4 mt-6">
          <div><Label>Username</Label><Input data-testid="reg-username" required value={form.username} onChange={u('username')} placeholder="creator" /></div>
          <div><Label>Display name</Label><Input data-testid="reg-display" value={form.display_name} onChange={u('display_name')} placeholder="Your name" /></div>
          <div><Label>Email</Label><Input data-testid="reg-email" type="email" required value={form.email} onChange={u('email')} placeholder="you@jixxeo.ai" /></div>
          <div><Label>Password</Label><Input data-testid="reg-password" type="password" required value={form.password} onChange={u('password')} placeholder="Min 6 chars" minLength={6} /></div>
          <div><Label>Referral code (optional)</Label><Input data-testid="reg-referral" value={form.referral_code} onChange={u('referral_code')} placeholder="FRIEND8X" /></div>
          <Button data-testid="reg-submit" type="submit" disabled={loading} className="w-full gradient-brand text-white">
            {loading ? 'Creating…' : 'Create account'}
          </Button>
        </form>
        <div className="text-sm text-slate-400 mt-6 text-center">
          Have an account? <Link to="/login" className="text-violet-400 hover:underline">Sign in</Link>
        </div>
      </Card>
    </div>
  );
}
